import React from 'react';

import {
  SUMMARY_ENTITY_PLANT_PROTECTION,
  SUMMARY_ENTITY_SOIL_INPUT,
  TASKS_GRID_MOA_TALLY_EMPTY,
  TASKS_GRID_MOA_TALLY_LABEL,
  TASKS_GRID_NUTRIENT_RATE_UNIT,
  TASKS_GRID_NUTRIENT_TALLY_EMPTY,
  TASKS_GRID_NUTRIENT_TALLY_LABEL,
} from 'constants/uiConstants';
import type { GUnit } from 'interfaces/IGlobalCatalogue';
import type { IInput } from 'interfaces/IInput';
import type { IInputTask } from 'interfaces/IInputTask';

import {
  buildTaskMoaGroups,
  buildTaskNutrientTally,
  formatNutrientRate,
} from './taskCaption';

interface TaskFilterTallyProps {
  task: IInputTask;
  planInput: IInput;
  gUnits: GUnit[];
  activeStepCategoryKey: string;
}

// The focused-view total under an expanded task's products (OP-2534): what
// the task applies with Soil Input filtered (nutrients, kg/ha, on the
// Nutrition lens's basis) and its MoA groups with Plant Protection filtered.
// Nothing in other views — these are for fine-tuning one input category.
const TaskFilterTally: React.FC<TaskFilterTallyProps> = ({
  task,
  planInput,
  gUnits,
  activeStepCategoryKey,
}) => {
  if (activeStepCategoryKey === SUMMARY_ENTITY_SOIL_INPUT) {
    const tally = buildTaskNutrientTally(task, planInput, gUnits);
    return (
      <div className="flex flex-wrap items-baseline gap-x-5 gap-y-1 border-l-2 border-success-dark px-2 pt-3">
        <span className="text-sm text-gray-dark">
          {TASKS_GRID_NUTRIENT_TALLY_LABEL}
        </span>
        {tally.length > 0 ? (
          tally.map(({ symbol, rate }) => (
            <span
              key={symbol}
              className="text-base font-semibold text-charcoal"
            >
              {symbol} {formatNutrientRate(rate)}{' '}
              <span className="text-sm font-normal text-gray-dark">
                {TASKS_GRID_NUTRIENT_RATE_UNIT}
              </span>
            </span>
          ))
        ) : (
          <span className="text-sm text-gray-dark">
            {TASKS_GRID_NUTRIENT_TALLY_EMPTY}
          </span>
        )}
      </div>
    );
  }

  if (activeStepCategoryKey === SUMMARY_ENTITY_PLANT_PROTECTION) {
    const groups = buildTaskMoaGroups(task);
    return (
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 border-l-2 border-success-dark px-2 pt-3">
        <span className="text-sm text-gray-dark">
          {TASKS_GRID_MOA_TALLY_LABEL}
        </span>
        {groups.length > 0 ? (
          groups.map((group) => (
            <span key={group} className="text-base font-semibold text-charcoal">
              {group}
            </span>
          ))
        ) : (
          <span className="text-sm text-gray-dark">
            {TASKS_GRID_MOA_TALLY_EMPTY}
          </span>
        )}
      </div>
    );
  }

  return null;
};

export default TaskFilterTally;
